import * as exBootstrap from '../../../bootstrap';

// ----------------------------------------------------------------------------

function toggle(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.toggle('Dropdown', element, config);
}

// ----------------------------------------------------------------------------

export default toggle;
